import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { tap } from "rxjs/operators";
import { LoaderService } from "../../common/services/loader.service";
import { ReportSelectorService } from "../../form-controls/services/report-selector.service";

@Injectable()
export class CommunicationGetMergeFields  {
    constructor(private service: ReportSelectorService,
        public loaderService: LoaderService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        this.loaderService.toggleLoader(true);

        if (route.paramMap.get('templateId')) {
            var templateId = route.paramMap.get('templateId')
            var mergeInfo = this.service.getMergeFields(templateId).pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
            return mergeInfo;
        }
    }
}